<subs-form-layout>
  <subs-form-content>
    <div class="card">
      <div class="card-header">
        Announcements
      </div>
      <div class="card-block">
        <div class="clr-row">
          <button
            type="button"
            class="clr-col-lg-auto"
            class="btn btn-sm"
            (click)="onAdd()"
            aria-label="Add Return Code"
            title="Add Return Code"
            data-test-id="addLine-button"
            style="margin: 0 0 0 0.5rem;"
          >
            Add
          </button>
        </div>
        <clr-datagrid>
          <clr-dg-column>Date</clr-dg-column>
          <clr-dg-column>Announcement</clr-dg-column>
          <clr-dg-column>Announcement Link</clr-dg-column>
          <clr-dg-column>Order Number</clr-dg-column>
          <clr-dg-column>Status</clr-dg-column>
          <clr-dg-row
            *ngFor="let announcement of announcements$ | async; let i = index"
          >
            <clr-dg-cell>
              <clr-input-container style="margin-top: 0">
                <input
                  type="date"
                  #date
                  (change)="updateAnnouncement(i, 'date', date.value)"
                  clrInput
                  [value]="announcement.date | date: 'yyyy-MM-dd'"
                />
              </clr-input-container>
            </clr-dg-cell>

            <clr-dg-cell>
              <form class="clr-form">
                <div class="clr-control-container" style="width: 100%;">
                  <textarea
                    type="string"
                    #announcementInput
                    (change)="
                      updateAnnouncement(
                        i,
                        'announcement',
                        announcementInput.value
                      )
                    "
                    [value]="announcement.announcementText"
                    class="clr-textarea"
                    style="width: 100%;"
                  ></textarea>
                </div>
              </form>
            </clr-dg-cell>

            <clr-dg-cell>
              <form class="clr-form">
                <div class="clr-control-container" style="width: 100%;">
                  <input
                    type="string"
                    placeholder="Link Format: https://www.google.com"
                    #announcementLink
                    (change)="
                      updateAnnouncement(
                        i,
                        'announcementLink',
                        announcementLink.value
                      )
                    "
                    [value]="announcement.announcementLink"
                    class="clr-textarea"
                    style="width: 100%;"
                  />
                </div>
              </form>
            </clr-dg-cell>

            <clr-dg-cell>
              <clr-input-container style="margin-top: 0">
                <input
                  type="number"
                  #orderNumber
                  (change)="
                    updateAnnouncement(i, 'orderNumber', orderNumber.value)
                  "
                  clrInput
                  [value]="announcement.orderNumber"
                />
              </clr-input-container>
            </clr-dg-cell>
            <clr-dg-cell>
              <select
                style="margin-top: 0; border: 0;"
                #status
                (change)="updateAnnouncement(i, 'status', status.value)"
                [value]="announcement.status"
              >
                <option>
                  Active
                </option>
                <option>
                  Inactive
                </option>
              </select>
            </clr-dg-cell>

            <clr-dg-action-overflow>
              <button
                type="button"
                class="action-item"
                (click)="deleteContact(i)"
                clrPopoverCloseButton
                data-test-id="delete"
              >
                Delete
              </button>
            </clr-dg-action-overflow>
          </clr-dg-row>
        </clr-datagrid>
        <clr-modal [(clrModalOpen)]="deleteOpened">
          <h3 class="modal-title">
            Confirm Delete?
          </h3>

          <div class="modal-body">
            <p>
              Are you sure you would like to delete?
            </p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline"
              (click)="cancelDeleteConfirmation()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="confirmDelete()"
              data-test-id="confirm-delete"
            >
              Delete
            </button>
          </div>
        </clr-modal>
      </div>
      <label *ngIf="invalidForm === true" style="color: red; margin-left: 2%;">
        *{{ errorMessage }}!
      </label>
    </div>
  </subs-form-content>

  <subs-form-buttons>
    <div style="display: flex;">
      <button
        type="button"
        class="btn btn-primary"
        [clrLoading]="submitState$ | async"
        (click)="save()"
        [disabled]="isSaved === false || invalidForm === true"
      >
        Save
      </button>
      <span
        *ngIf="isSaved === false"
        class="spinner spinner-md"
        style="margin-top: 5px;"
      ></span>
    </div>
  </subs-form-buttons>
</subs-form-layout>

<clr-modal [clrModalOpen]="showSavedModal" [clrModalClosable]="true">
  <h3 class="modal-title">
    Successfully Saved
  </h3>
  <div class="modal-body">
    Changes to the Announcements were successfully saved.
  </div>
  <div class="modal-footer"></div>
</clr-modal>
